var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3093 20.3093C19.5031 21.1155 18.1593 21.1155 17.3531 20.3093L10.5 13.4562L3.64686 20.3093C2.84064 21.1155 1.49682 21.1155 0.690601 20.3093C-0.115617 19.5031 -0.115617 18.1593 0.690601 17.3531L7.5437 10.5L0.690601 3.64686C-0.115617 2.84064 -0.115617 1.49682 0.690601 0.690601C1.49682 -0.115617 2.84064 -0.115617 3.64686 0.690601L10.5 7.5437L17.3531 0.690601C18.1593 -0.115617 19.5031 -0.115617 20.3093 0.690601C21.1155 1.49682 21.1155 2.84064 20.3093 3.64686L13.4562 10.5L20.3093 17.3531C21.1155 18.1593 21.1155 19.503 20.3093 20.3093Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.17e5f4e63362eead09f6e3fb3ab59b36.svg";
export { ForwardRef as ReactComponent };